import { useCallback } from 'react';
import SidenavService from './service';
import { useRequest } from '../utils/customHooks';

export const useFetchNavigation = validationCallback => {
    const SidenavAPI = new SidenavService();
    return useRequest(useCallback(SidenavAPI.getNavigation, []), validationCallback, () => {});
};
